export const enum FirmwareUpdateMode {
  UpdateDevices,
  UpdateNetwork,
  UpdateByCpoName,
  UpdateByDaze
}
